// @flow
import React from 'react';
import DatePicker from 'react-date-picker';
import { format } from 'date-fns';
// eslint-disable-next-line import/named
import type { IntlShape } from 'react-intl';

// Constants
import { getDateFormat, getLocale } from 'constants/date';

import cn from 'classnames';
import './DesktopDatePicker.scss';

const ns = 'desktop-date-picker';

type Props = {
  className?: string,
  disabled?: boolean,
  minDate: Date,
  maxDate: Date,
  onChange: (date: Date) => void,
  value: string,
  minDetail?: string,
  locale: string,
  languageCode: string,
  intl: IntlShape
};

type State = {
  isOpenDesktopDatePicker: boolean
};

class DesktopDatePicker extends React.Component<Props, State> {
  state = {
    isOpenDesktopDatePicker: false
  };
  handleClick = () => {
    this.setState({ isOpenDesktopDatePicker: true });
  };

  handleCancel = () => {
    this.setState({ isOpenDesktopDatePicker: false });
  };

  render() {
    const {
      className,
      disabled,
      onChange,
      minDate,
      maxDate,
      value,
      minDetail,
      locale,
      languageCode,
      intl
    } = this.props;
    const { isOpenDesktopDatePicker } = this.state;
    const classProps = cn(ns, className);
    const buttonText = format(value, getDateFormat(locale), {
      locale: getLocale(languageCode)
    });
    const localeFormatted = locale.replace('_', '-');
    return (
      <div className={classProps}>
        <DatePicker
          disabled={disabled}
          isOpen={isOpenDesktopDatePicker}
          minDate={minDate}
          maxDate={maxDate}
          onCalendarClose={this.handleCancel}
          onChange={e => onChange(e)}
          value={value}
          minDetail={minDetail}
          locale={localeFormatted}
          dayAriaLabel={intl.formatMessage({
            id: 'c8.aria.date.picker.day',
            defaultMessage: 'Day selected'
          })}
          monthAriaLabel={intl.formatMessage({
            id: 'c8.aria.date.picker.month',
            defaultMessage: 'Month selected'
          })}
          yearAriaLabel={intl.formatMessage({
            id: 'c8.aria.date.picker.year',
            defaultMessage: 'Year selected'
          })}
        />
        <button
          disabled={disabled}
          className={`${ns}__select-btn`}
          onClick={this.handleClick}
        >
          {buttonText}
        </button>
      </div>
    );
  }
}

export default DesktopDatePicker;



// WEBPACK FOOTER //
// ./src/components/atoms/DesktopDatePicker/DesktopDatePicker.js